<template>
    <div>
        <AgItem :columnDefs="columnDefs"
                :rowData="rowData"
                v-on:sortChanged="sortChanged"
        ></AgItem>
        <Pagination
                :totalNum="totalNum"
                :pageSize="pageSize"
                :sizeChange="sizeChange"
                :currentChange="currentChange"
                :currentPage="page"
        ></Pagination>
        <CustomRatingEditModal
                v-if="editModalDisplayed"
                :company-id="editModalCompanyId"
				:config="config"
                @close="closeEditModal"
                @submit="confirmSubmitEdit"
        ></CustomRatingEditModal>
    </div>
</template>

<script>
import {customRatingsApi} from "@/common/api/customRatingsApi";
import {asDecimal, asLocalizedDate, asMoneyAmount} from "@/components/templates/agGrid/formatter/valueFormatters";
import AgItem from "@/components/templates/agGrid/AgItem.vue";
import Pagination from "@/components/templates/common/Pagination.vue";
import PaginationParent from "@/components/templates/common/PaginationParent.vue";
import CustomRatingEditModal from "@/components/templates/investor/riskAssessment/customRatings/CustomRatingEditModal.vue";

export default {
		extends: PaginationParent,
		components: {
			CustomRatingEditModal,
			AgItem,
			Pagination
		},
		props: {
			filters: { type: Array, default: [] },
			config: { type: Object, default: null }
		},
		data() {
			return {
				columnDefs: [],
				rowData: null,
				sorting: [],
                editModalDisplayed: false,
				editModalCompanyId: null
			};
		},
		beforeMount() {
			this.setColumnDefs();
			this.getList();
		},
		methods: {
			setColumnDefs() {
				this.columnDefs = [
					{
						headerName: this.$t("common.company"),
						minWidth: 200,
						field: "companyName",
						nameType: "companyName",
						idType: "ratedCompanyId",
						cellRendererFramework: "CompanyTem",
						sortable: true
					},
					{
						headerName: this.$t("common.country"),
						minWidth: 100,
						maxWidth: 150,
						field: "country",
						sortable: true
					},
					{
						headerName: this.$t("common.vatId"),
						minWidth: 120,
						field: "vatNumber",
						sortable: true
					},
					{
						headerName: this.$t("common.street"),
						minWidth: 200,
						field: "street",
						sortable: true,
					},
					{
						headerName: this.$t("common.postcode"),
						minWidth: 80,
						maxWidth:120,
						field: "postCode",
						sortable: true,
					},
					{
						headerName: this.$t("common.city"),
						minWidth: 80,
						maxWidth:150,
						field: "city",
						sortable: true,
					},
					{
						headerName: this.$t("common.lastPurchase"),
						field: "lastPurchaseTime",
						valueFormatter: asLocalizedDate(),
						minWidth: 100,
						maxWidth: 200,
						sortable: true
					},
					{
						headerName: this.config.nameRating1OrDefault,
						// headerClass: "align-right",
						field: "rating1",
						// cellStyle: {'justify-content': 'flex-end'},
						valueFormatter: asDecimal({decimals: 0}),
						minWidth: 100,
						maxWidth: 120,
						sortable: true
					},
					{
						headerName: this.config.nameRating2OrDefault,
						// headerClass: "align-right",
						field: "rating2",
						// cellStyle: {'justify-content': 'flex-end'},
						valueFormatter: asDecimal({decimals: 0}),
						minWidth: 100,
						maxWidth: 120,
						sortable: true
					},
					{
						headerName: this.config.nameRating3OrDefault,
						// headerClass: "align-right",
						field: "rating3",
						// cellStyle: {'justify-content': 'flex-end'},
						valueFormatter: asDecimal({decimals: 0}),
						minWidth: 100,
						maxWidth: 120,
						sortable: true
					},
					{
						headerName: this.$t("common.updateDate"),
						field: "lastUpdateTime",
						valueFormatter: asLocalizedDate(),
						minWidth: 100,
						maxWidth: 200,
						sortable: true
					},
					{
						headerName: this.$t("common.actions"),
						cellRendererFramework: "CustomRatingTableOperation",
						cellRendererParams: {
							showEditModal: this.showEditModal,
							deleteRating: this.confirmDeleteRating
						},
						minWidth: 140,
						maxWidth: 140,
						pinned: "right",
					},
				];
			},
			sortChanged(sortData) {
				this.sorting = sortData;
				this.initPage();
				this.getList();
			},
			getList() {
				let postData = {
					columns: [],
					filters: this.filters || [],
					maxResults: this.maxResults,
					offset: this.offset,
					sorting: this.sorting
				};

				customRatingsApi.inspection.listCustomRatings(postData)
					.then(res => {
						this.setTotalNum(res.recordsTotal);
						this.rowData = res.data;
					})
					.catch(this.toast);
			},
            showEditModal(companyId) {
				this.editModalDisplayed = true;
				this.editModalCompanyId = companyId;
            },
            closeEditModal() {
				this.editModalDisplayed = false;
				this.editModalCompanyId = null;
            },
			confirmDeleteRating(companyId) {
				let option = {
					msg: this.$t("customRating.delete.confirmation.msg"),
					confirmFun: this.submitDelete,
					params: companyId
				};
				this.confirmMeg(option, true);
			},
			submitDelete(companyId) {
				customRatingsApi.operation.deleteCustomRating(companyId)
					.then(() => {
						this.toastSuccess();
						this.getList();
					})
					.catch(this.toast);
			},
			confirmSubmitEdit(data) {
				let option = {
					msg: this.$t("customRating.editModal.confirmation.msg"),
					confirmFun: this.submitEdit,
					params: data
				};
				this.confirmMeg(option, true);
			},
			submitEdit(data) {
				customRatingsApi.operation.saveCustomRating(data.companyId, data)
                    .then(() => {
                    	this.closeEditModal();
				        this.toastSuccess();
				        this.getList();
                    })
                    .catch(this.toast);
            }
		},
		watch: {
			filters() {
				this.getList();
			},
			config() {
				this.setColumnDefs();
			}
		}
	};
</script>